module.exports = __webpack_public_path__ + "img/auxilio_funeral.ada58967.svg";